import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-popuptest',
  templateUrl: './popuptest.component.html',
  styleUrls: ['./popuptest.component.scss']
})
export class PopuptestComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  closePopup() {
    // Providing a `null` value to the named outlet
    // clears the contents of the named outlet
    this.router.navigate([{ outlets: { popup: null }}]);
  }

}
